import { render, staticRenderFns } from "./GeneralRepair.vue?vue&type=template&id=b587ad7c"
import script from "./GeneralRepair.vue?vue&type=script&lang=js"
export * from "./GeneralRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports